import axios, { AxiosError } from 'axios'
import { defaultRequestInterceptors, defaultResponseInterceptors } from './config'

import { AxiosInstance, InternalAxiosRequestConfig, RequestConfig, AxiosResponse } from './types'
import { ElMessage } from 'element-plus'
import { REQUEST_TIMEOUT } from '@/constants'

export const PATH_URL = import.meta.env.VITE_API_BASE_PATH

// 简化的请求管理 - 移除AbortController依赖
const pendingRequests = new Set<string>()

const axiosInstance: AxiosInstance = axios.create({
  timeout: REQUEST_TIMEOUT,
  baseURL: PATH_URL
})

axiosInstance.interceptors.request.use((res: InternalAxiosRequestConfig) => {
  const url = res.url || ''
  if (import.meta.env.VITE_USE_MOCK === 'false') {
    res.url = res.url?.replace('/mock', '/webapi')
  }
  // 简单的重复请求检测
  const requestKey = `${res.method}-${url}`
  if (pendingRequests.has(requestKey)) {
    console.warn(`重复请求被阻止: ${requestKey}`)
  }
  pendingRequests.add(requestKey)
  return res
})

axiosInstance.interceptors.response.use(
  (res: AxiosResponse) => {
    const url = res.config.url || ''
    const method = res.config.method || ''
    const requestKey = `${method}-${url}`
    pendingRequests.delete(requestKey)
    // 这里不能做任何处理，否则后面的 interceptors 拿不到完整的上下文了
    return res
  },
  (error: AxiosError) => {
    const url = error.config?.url || ''
    const method = error.config?.method || ''
    const requestKey = `${method}-${url}`
    pendingRequests.delete(requestKey)
    console.log('err： ' + error) // for debug
    ElMessage.error(error.message)
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.request.use(defaultRequestInterceptors)
axiosInstance.interceptors.response.use(defaultResponseInterceptors)

const service = {
  request: (config: RequestConfig) => {
    return new Promise((resolve, reject) => {
      if (config.interceptors?.requestInterceptors) {
        config = config.interceptors.requestInterceptors(config as any)
      }

      axiosInstance
        .request(config)
        .then((res) => {
          resolve(res)
        })
        .catch((err: any) => {
          reject(err)
        })
    })
  },
  cancelRequest: (url: string | string[]) => {
    console.warn('取消请求功能已简化，当前实现仅用于重复请求检测')
    // 这里可以实现基于URL的请求过滤逻辑
  },
  cancelAllRequest() {
    console.warn('取消所有请求功能已简化，当前实现仅用于重复请求检测')
    pendingRequests.clear()
  }
}

export default service